import React from "react";
import { motion } from "framer-motion";
import { Phone, Siren } from "lucide-react";
import { useContent } from "../ContentContext";

export default function EmergencyBanner() {
  const { company } = useContent();
  if (!company.emergency_247) return null;
  return (
    <section data-testid="emergency-banner" className="relative overflow-hidden" style={{ background: "#B02019" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-5">
          <motion.div initial={{ scale: 0.8, opacity: 0 }} whileInView={{ scale: 1, opacity: 1 }} viewport={{ once: true }}
            className="w-16 h-16 rounded-2xl flex items-center justify-center shrink-0" style={{ background: "rgba(255,255,255,0.15)" }}>
            <Siren size={30} style={{ color: "var(--sun)" }} />
          </motion.div>
          <div>
            <div className="text-xs font-bold tracking-[0.25em] uppercase" style={{ color: "var(--sun)" }}>Available 24 hours · 7 days</div>
            <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl leading-[0.95]" style={{ color: "#fff" }}>
              24/7 Emergency Tree Service
            </h2>
            <p className="mt-2 text-sm sm:text-base max-w-xl" style={{ color: "rgba(255,255,255,0.85)" }}>
              Fallen tree? Storm damage? Dangerous limb? Call us any time, day or night — we respond fast.
            </p>
          </div>
        </div>
        <a href={`tel:${company.phoneRaw}`} data-testid="emergency-call-btn"
           className="inline-flex items-center gap-3 rounded-full px-8 py-4 text-lg font-extrabold uppercase tracking-wide shadow-2xl transition-transform hover:scale-105 shrink-0"
           style={{ background: "var(--sun)", color: "var(--pine)" }}>
          <Phone size={22} /> {company.phone}
        </a>
      </div>
    </section>
  );
}
